/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
import FormatSymbols from './FormatSymbols';
//@import BaseMoserObject (loadtime) // superclass
//@import FormatSymbols (runtime) // getListSeparator

/**
 * Util class to build simple V5 macros.
 * @author  PASCALLacombe
 */
export default class MacroUtil extends BaseMoserObject{

	/**
	 * Wraps and escapes a literal value if its a String.
	 * @param {BaseMoserObject} value
	 */
	static getLiteral(value) {
		if (value == null) {
			return null;
		} else if ((typeof value === "string" || value instanceof String)) {
			var result = "'";
			result+=(value);
			result+=("'");
			return result;
		}
		return value.toString();
	}

	/**
	 * Create a GetResourceString macro function
	 * @param {String} value
	 * @return {String}
	 */
	static getResourceString(value) {
		var result = "GetResourceString( ";
		result+=(value);
		result+=(" )");
		return result;
	}

	/**
	 * Injects another macro inside a string by escaping the string on each end
	 * @param {String} value
	 * @return {String}
	 */
	static injectMacro(value) {
		var expression = "'' + ";
		expression+=(value);
		expression+=(" + ''");
		return expression;
	}

	/**
	 * Wrap an expression as a macro.
	 * @param {String} expression
	 * @return {String}
	 */
	static macro(expression) {
		var result = "#";
		result+=(expression);
		result+=("#");
		return result;
	}

	/**
	 * Wrap a nested V5 expression as a macro string.
	 * @param {String} expression
	 * @return {String}
	 */
	static macroAsString(expression) {
		var result = "\"'\" + ";
		result+=(expression);
		result+=(" + \"'\"");
		return result;
	}

	/**
	 * Create a sq macro function
	 * @param {String} value
	 * @return {String}
	 */
	static sq(value) {
		var result = "sq( ";
		result+=(value);
		result+=(" )");
		return result;
	}

	/**
	 * Create a substitute macro function
	 * @param {String} oldValue
	 * @param {String} newValue
	 * @param {String} value
	 * @param {String} expressionLocale
	 * @return {String}
	 */
	static substitute(oldValue, newValue, value, expressionLocale) {
		var listSeparator = FormatSymbols.getListSeparator(expressionLocale);
		var result = "substitute( ";
		result+=(oldValue);
		result+=(listSeparator);
		result+=(" ");
		result+=(newValue);
		result+=(listSeparator);
		result+=(" ");
		result+=(value);
		result+=(" )");
		return result;
	}

	/**
	 * Create a substr macro function
	 * @param {String} value
	 * @param {int} offset
	 * @param {String} expressionLocale
	 * @return {String}
	 */
	static substr(value, offset, expressionLocale) {
		var listSeparator = FormatSymbols.getListSeparator(expressionLocale);
		var result = "substr( ";
		result+=(value);
		result+=(listSeparator);
		result+=(" ");
		result+=(offset);
		result+=(" )");
		return result;
	}

	/**
	 * Constructor
	 */
	//constructor() 
}


// WEBPACK FOOTER //
// ./src/generated/MacroUtil.js